import { SvgIcon } from '@mui/material';

const NonPerishableIcon = (props) => {
  return (
    <SvgIcon {...props}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="17"
        height="16"
        viewBox="0 0 17 16"
        fill="none"
      >
        <path
          d="M13.9 1.5H3.2v2.085h10.7zM6.6 3.6h3.9a3.6 3.6 0 0 1 3.6 3.6v7.5H3V7.2a3.6 3.6 0 0 1 3.6-3.6M3 8.2h11.15M3 12.55h11.15m-6-2.3h3.8m-6.75 0h.9"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </SvgIcon>
  );
};

export default NonPerishableIcon;
